module.exports = __webpack_public_path__ + "help/technicalHistory.md";